import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export interface AppStoreProps {
  pageLoading: boolean;
  sideBarVisible: boolean;
  sideBarToggle: () => void;
  pageLoadingToggle: (v: boolean) => void;
}

export const useAppStore = create<AppStoreProps>()(
  devtools(
    persist(
      (set) => ({
        pageLoading: false,
        sideBarVisible: true,
        sideBarToggle: () => set((state) => ({ sideBarVisible: !state.sideBarVisible })),
        pageLoadingToggle: (v) => set(() => ({ pageLoading: v })),
      }),
      {
        name: 'app-storage', // LocalStorage key for persist
      }
    ),
    { name: 'AppStore' } // DevTools debugging identifier
  )
);
